export const modesInfo = [
  {
    name: "Stationary Mode",
    instruction: "Click the stationary button as fast as you can!",
  },
  {
    name: "Moving Mode",
    instruction: "The button moves around—keep clicking it!",
  },
  {
    name: "Teleport Mode",
    instruction: "The button teleports every few seconds—click it!",
  },
];

// Duration of the game in seconds
export const GAME_DURATION = 15;

export const initialModal = (modeInfo) => ({
  title: "Welcome to Rapid Clicker!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Welcome to: <strong>{modeInfo.name}</strong>
      </div>
      <div className="modal-description-contents">{modeInfo.instruction}</div>
      <div className="modal-description-footer">
        You have {GAME_DURATION} seconds. Timer starts when you click the "Click
        Me!" button.
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const endGameModal = (modeInfo, clickCount) => ({
  title: "Game Over!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Mode: <strong>{modeInfo.name}</strong>
      </div>
      <div className="modal-description-contents">
        <p>
          Your Score: <span className="highlight-blue">{clickCount}</span>{" "}
          clicks
        </p>
        <p>
          Average Rate:{" "}
          <span className="highlight-blue">
            {(clickCount / GAME_DURATION).toFixed(2)}
          </span>{" "}
          clicks/sec
        </p>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});
